var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-option"},[_c('b-form-radio',{attrs:{"value":_vm.value}},[_c('img',{staticClass:"mr-2 logo",attrs:{"src":_vm.logoSrc,"alt":"Logo"}}),_vm._v(" "+_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }